
@switch (currentLang) {

  @case ('da') {
    <span [ngClass]="{'notBoldSpan' : notBold}">{{content?.name}}</span>
  }
  @case ('en') {
    <span [ngClass]="{'notBoldSpan' : notBold}">{{content?.nameUk}}</span>
  }
}
